var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "#F04438"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 3,
    height: 8,
    rx: 1.5,
    fill: "#F04438"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 3,
    height: 12,
    rx: 1.5,
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/high.92ab8f17233ca20863c05680cb56519e.svg";
export { ForwardRef as ReactComponent };